import React, { useMemo, useState } from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import SwapCallsOutlinedIcon from '@mui/icons-material/SwapCallsOutlined'

import { AddressInput } from '../inputs'
import {
  AddressSwapProvider, AddressSwapState, DirectionType, InitialSwapContext,
} from '../../contexts'

const AddressSwapPage = (): JSX.Element => {
  const [state, setState] = useState<AddressSwapState>(InitialSwapContext)

  const swapDirection = () => {
    setState({
      [DirectionType.INPUT]: {
        type: state[DirectionType.OUTPUT].type,
        value: state[DirectionType.OUTPUT].value,
      },
      [DirectionType.OUTPUT]: {
        type: state[DirectionType.INPUT].type,
        value: state[DirectionType.INPUT].value,
      },
    })
  }

  const value = useMemo(() => ({ state, setState }), [state, setState])

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      flexDirection="column"
    >
      <AddressSwapProvider value={value}>
        <Box>
          <AddressInput
            direction={DirectionType.INPUT}
          />
        </Box>
        <Box
          mt={1}
          mb={1}
        >
          <Button
            aria-label="swap"
            color="secondary"
            variant="contained"
            onClick={swapDirection}
            sx={{
              color: '#ffffff',
              borderRadius: '50px',
              backgroundColor: '#505050',
              minWidth: 20,
              padding: 1.5,
            }}
          >
            <SwapCallsOutlinedIcon />
          </Button>
        </Box>
        <Box>
          <AddressInput
            direction={DirectionType.OUTPUT}
            disabled
          />
        </Box>
      </AddressSwapProvider>
    </Box>
  )
}

export default AddressSwapPage
